import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/auth/AuthContext'
import { requestErrorMessage } from '@/helpers/apiClient'

/**
 * Enter a tenant as a super admin (support mode) and navigate to the tenant
 * home. Shared by the tenants list and tenant detail pages.
 */
export function useEnterTenant() {
  const { enterTenant } = useAuth()
  const navigate = useNavigate()
  const [enteringId, setEnteringId] = React.useState<string | null>(null)
  const [error, setError] = React.useState<string | null>(null)

  const enter = React.useCallback(
    async (tenantId: string): Promise<void> => {
      setError(null)
      setEnteringId(tenantId)
      try {
        await enterTenant(tenantId)
        navigate('/events', { replace: true })
      } catch (e) {
        setError(requestErrorMessage(e))
        setEnteringId(null)
      }
    },
    [enterTenant, navigate],
  )

  return {
    enter,
    enteringId,
    isEntering: enteringId !== null,
    error,
  }
}
